import React from 'react';
import styled from 'styled-components';
import { LoanFormatIcon } from '../../../shared/common/GildIcon';
import { UsageStatisticsOut } from '../../../store/api';
import { useTranslation } from 'react-i18next';

const StProductGroupStatistics = styled.span.attrs({
    'data-displayname': 'ProductGroupStatistics'
})``;
const StAmountBadge = styled.span.attrs({ className: 'marker-badge margin display-inline-flex gild' })<{
    backgroundColor?: string;
}>`
    background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'unset')};
`;

const Badge = ({ count, icon, color, title }) => {
    return count > 0 ? (
        <StAmountBadge title={title}>
            <LoanFormatIcon icon={icon} aria-hidden={true} className={`loanformat-icon-small-${color}`} />
            <span>{count}</span>
        </StAmountBadge>
    ) : null;
};

interface Props {
    usageStatistics: UsageStatisticsOut;
}

export const ProductGroupStatistics = ({ usageStatistics }: Props) => {
    const { t } = useTranslation();
    return (
        <StProductGroupStatistics>
            <Badge
                count={usageStatistics.ebooksAmountOnSite}
                icon={'ebook-filled'}
                color="black"
                title={t('marketing.productGroups.statistics.totalEbooks')}
            />
            <Badge
                count={usageStatistics.ebooksLoanableOnSite}
                icon={'ebook-filled'}
                color="primary"
                title={t('marketing.productGroups.statistics.availableEbooks')}
            />
            <Badge
                count={usageStatistics.ebooksOnLoanOnSite}
                icon={'ebook-filled'}
                color="warning"
                title={t('marketing.productGroups.statistics.eBooksOnLoan')}
            />
            <Badge
                count={usageStatistics.eaudiobooksAmountOnSite}
                icon={'eaudiobook-filled'}
                color="black"
                title={t('marketing.productGroups.statistics.totalEAudoibooks')}
            />
            <Badge
                count={usageStatistics.eaudiobooksLoanableOnSite}
                icon={'eaudiobook-filled'}
                color="primary"
                title={t('marketing.productGroups.statistics.availableEAudiobooks')}
            />
            <Badge
                count={usageStatistics.eaudiobooksOnLoanOnSite}
                icon={'eaudiobook-filled'}
                color="warning"
                title={t('marketing.productGroups.statistics.eAudiobooksOnLoan')}
            />
            <Badge
                count={usageStatistics.epressAmountOnSite}
                icon={'emagazine-filled'}
                color="black"
                title={t('marketing.productGroups.statistics.totalEpress')}
            />
            <Badge
                count={usageStatistics.epressLoanableOnSite}
                icon={'emagazine-filled'}
                color="primary"
                title={t('marketing.productGroups.statistics.availableEpress')}
            />
            <Badge
                count={usageStatistics.epressOnLoanOnSite}
                icon={'emagazine-filled'}
                color="warning"
                title={t('marketing.productGroups.statistics.ePressOnLoan')}
            />
        </StProductGroupStatistics>
    );
};
